import styled from 'styled-components'
import { COLOUR } from '../../__constants__'


export const H1 = styled.div`
    font-family: Mada;
    font-size: 29px;
    font-weight: 400;
    letter-spacing: 0em;
    text-align: left;
`

export const H2 = styled.div`
    font-family: Mada;
    font-size: 22px;
    font-weight: 700;
    text-align: left;
`

export const DownloadPluginHeader = styled.div`
font-family: Mada;
font-size: 18px;
font-weight: 500;
color: ${COLOUR.DOWNLOAD_HEADER_FONT_COLOUR};
letter-spacing: 0em;
text-align: left;
width: 100%;
height: 34px;
background-color: ${COLOUR.PLUGIN_HEADERS_COLOUR};
display: flex;
flex-direction: column;
justify-content: center;
padding-left: 8px;
`

export const AppContainer = styled.div`
 display: flex;
 justify-content: center;
 align-items: center;
 height: 100vh; 
 width: 100%;
`
export const IPAPage = styled.div`
    width: 1200px;
    height: 720px;
    background-color: white;
    border-radius: 64px;
    display: flex;
    flex-direction: row;
    column-gap: 2;
`

export const MenuSection = styled.div`
     height: 720px;
     width: 600px; 
     border-right: ${1}px solid ${COLOUR.BODY_BACKGROUND};
     display: flex;
     flex-direction: column;
     align-items: center
    `

export const LogoSection = styled.div`
     width: 231px;
     height: 100px; 
     margin-top: 68px;
`
export const PluginsSection = styled.div`
     margin-top: 68px;
     width: 220px;
`

export const MenifestSection = styled.div`
    width: 100%;
    margin: 118px 32px;
`

export const Manifest = styled.div`
    height: 454px;
    padding: 0px 16px 20px 0px;
    display: flex;
    flex-direction: column;
    overflow-y: scroll;
    overflow-x: hidden;
    box-sizing: border-box;

    &::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 7px;
      }
      
    &::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: rgba(0, 0, 0, .5);
        box-shadow: 0 0 1px rgba(255, 255, 255, .5);
      }
`
export const Plugins = styled.div`
    margin-top: 32px;
    height: 400px;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    box-sizing: border-box;
`
